// router
import { useTranslation } from 'react-i18next';

// mui
import { Grid, Typography, TypographyProps } from '@mui/material';

// ui
import { Flag } from '../Flag/Flag';

// utils
import { flagsByCurrency } from '../../../utils/currency';

export interface CurrencyProps {
	currency: string;
	TypographyProps?: TypographyProps;
}

export const Currency = ({ currency, TypographyProps }: CurrencyProps) => {
	// hooks
	const { t } = useTranslation();

	if (currency) {
		return (
			<Grid alignItems="center" container spacing={1}>
				<Grid item xs="auto">
					<Flag code={flagsByCurrency[currency]} />
				</Grid>
				<Grid item xs="auto">
					<Typography fontWeight={600} {...TypographyProps}>
						{currency}
					</Typography>
				</Grid>
			</Grid>
		);
	}

	return <Typography>{t('na')}</Typography>;
};
